import { render, staticRenderFns } from "./ExtratoHonorariosAcaoJudicial.vue?vue&type=template&id=213c09d0&scoped=true&"
import script from "./ExtratoHonorariosAcaoJudicial.vue?vue&type=script&lang=js&"
export * from "./ExtratoHonorariosAcaoJudicial.vue?vue&type=script&lang=js&"
import style0 from "./ExtratoHonorariosAcaoJudicial.vue?vue&type=style&index=0&id=213c09d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213c09d0",
  null
  
)

export default component.exports